import React from 'react';

import { DateRangeIcon, Stack } from '@gogame/components';

import PlannedSchedule from 'scenes/Gallery/GalleryPage/Concepts/ConceptDetails/components/PlannedSchedule';
import * as CONCEPT from 'scenes/Gallery/GalleryPage/Concepts/view-constants';
import StatusBadge from 'scenes/Gallery/components/StatusBadge';

const StatusColumn = ({ row, value }) => {
  const { [CONCEPT.STATE_SCHEDULES]: stateSchedules } = row;

  return (
    <Stack direction={'row'} spacing={1} alignItems={'center'}>
      <StatusBadge id={value} />
      {stateSchedules?.length > 1 && (
        <PlannedSchedule
          data={stateSchedules}
          icon={<DateRangeIcon fontSize={'small'} color={'action'} />}
        />
      )}
    </Stack>
  );
};
export default StatusColumn;
